import MONTH_SELECT_OPTIONS from "constants/monthSelectOptions";

export const getMonthLabel = (value: string): string | undefined => {
    return MONTH_SELECT_OPTIONS.find((m) => m.value === value)?.label;
};
